var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#9E1B3C",
    d: "M55.817,69.491l7.285,7.573l1.287-1.238                 c1.002-0.964,2.607-0.932,3.57,0.069l12.938,13.446c0.963,1,0.932,2.607-0.069,3.571l-6.65,6.398                 c-1.002,0.963-2.609,0.932-3.571-0.068L57.67,85.796c-0.963-1-0.932-2.607,0.068-3.571l1.287-1.237l-7.285-7.573L55.817,69.491                 L55.817,69.491z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#F48120",
    d: "M37.315,23.737c16.004,0,28.98,12.975,28.98,28.979                 c0,16.006-12.977,28.98-28.98,28.98c-16.005,0-28.98-12.975-28.98-28.98C8.335,36.712,21.31,23.737,37.315,23.737L37.315,23.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFF100",
    d: "M37.315,33.181c10.789,0,19.535,8.747,19.535,19.536                 c0,10.79-8.746,19.537-19.535,19.537s-19.537-8.747-19.537-19.537C17.779,41.928,26.526,33.181,37.315,33.181L37.315,33.181z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#9E1B3C",
    d: "M11.409,6.033l2.06,20.216c3.692-3.358,8.095-5.947,12.957-7.52                 L11.409,6.033L11.409,6.033z M90.634,50.479l-18.95-7.315c0.817,2.995,1.258,6.146,1.258,9.399c0,1.892-0.149,3.746-0.434,5.557                 L90.634,50.479L90.634,50.479z M77.282,17.238l-19.304,6.336c4.103,2.92,7.558,6.69,10.11,11.052L77.282,17.238L77.282,17.238z                  M46.235,0.014L35.191,17.075c0.725-0.044,1.456-0.069,2.191-0.069c4.445,0,8.699,0.818,12.622,2.308L46.235,0.014L46.235,0.014z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaFav);
export default __webpack_public_path__ + "static/media/fa_fav.48931612.svg";
export { ForwardRef as ReactComponent };